import React from 'react';
import styled from 'styled-components';

import { colors, padding } from '@grnhse/seedling/lib/azalea/constants';
import { withLocalePrefix } from 'shared/utils/translation';

import moment from 'moment-timezone';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import TimeSlotInput from 'shared/components/dates/TimeSlotInput';
import type { TimeSlotValue } from 'shared/components/dates/TimeSlotInput';

// @ts-expect-error - TS7016 - Could not find a declaration file for module './styles'. 'app/webpack/javascripts/candidate_availability/styles.js' implicitly has an 'any' type.
import { AvailabilityContainer } from './styles';

const t = withLocalePrefix('availability.choose_availability');

type SuggestedTimeSlotState = {
  // used to keep track of what suggested time has been added to the list of candidate times
  alreadyAdded?: boolean;
};

export type SuggestedTimeSlot = TimeSlotValue & SuggestedTimeSlotState;

type Props = {
  suggestedTimes: Array<SuggestedTimeSlot>;
  addSuggestedTimeAsAvailability: (arg1: SuggestedTimeSlot) => unknown;
};

export default class SuggestedTimes extends React.PureComponent<Props> {
  renderSuggestedTime(suggestedTimeRange: SuggestedTimeSlot) {
    const { addSuggestedTimeAsAvailability } = this.props;

    const min = moment(Date.now());
    const max = moment(Date.now()).add(3, 'months');

    const hasDateAlreadyPassed = moment(suggestedTimeRange.start).isBefore(
      moment()
    );

    const addSuggestedTime = () => {
      if (!hasDateAlreadyPassed) {
        addSuggestedTimeAsAvailability(suggestedTimeRange);
      }
    };

    return (
      <SuggestedTimeAvailabilityContainer
        key={suggestedTimeRange.id}
        hidden={suggestedTimeRange.alreadyAdded}
        className="suggested-time-container"
        data-provides="suggested-time-container"
      >
        <TimeSlotInput
          // @ts-expect-error - TS2769 - No overload matches this call.
          className="suggested-time"
          min={min}
          max={max}
          value={suggestedTimeRange}
          disabled={true}
        />

        {hasDateAlreadyPassed ? (
          <PastCaption>{t('suggested_times.past_time')}</PastCaption>
        ) : (
          <Button className="add-suggested-time" onClick={addSuggestedTime}>
            {t('actions.select_suggested_availability')}
          </Button>
        )}
      </SuggestedTimeAvailabilityContainer>
    );
  }

  render() {
    const { suggestedTimes } = this.props;

    return (
      <Container>
        {suggestedTimes.map((timeRange) => this.renderSuggestedTime(timeRange))}
      </Container>
    );
  }
}

const Container = styled.div`
  // need to do it here and with explicit classes to avoid adjancency selectors failing due
  // the generated classes being different (when one is hidden vs when it's shown)
  .suggested-time-container + .suggested-time-container {
    margin-top: ${padding.normal};
  }
`;

const addButtonWidth = '100px';
export const SuggestedTimeAvailabilityContainer = styled(AvailabilityContainer)`
  ${(props) =>
    props.hidden &&
    `
    display: none;
  `}

  .suggested-time {
    display: inline-block;
    vertical-align: middle;
    margin-right: ${padding.small};
    width: calc(100% - ${addButtonWidth} - ${padding.small});
  }

  .add-suggested-time {
    display: inline-block;
    vertical-align: middle;
    width: ${addButtonWidth};
  }
`;

export const PastCaption = styled.span`
  display: inline-block;
  color: ${colors.mediumGrey};
  font-style: italic;

  text-align: center;

  // since this is going in place of the add suggested time button,
  // it should take up the same space to keep things consistent.
  width: ${addButtonWidth};
`;
